'use client';
import React, { useState, useEffect, useRef, useCallback } from 'react';
import { v4 as uuidv4 } from 'uuid';
// import Button from "@mui/material/Button";
// import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { useUserContext } from '../contexts/UserContext';
import * as _ from 'lodash';
import Cookies from 'js-cookie';
import {
  MagnifyingGlassIcon,
  ArrowUpIcon,
  ArrowDownIcon,
  ArrowsUpDownIcon,
  ArrowTopRightOnSquareIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
  DeleteIcon,
} from '@heroicons/react/24/outline';
import mqtt from 'mqtt';

let signalstopic = 'goldensparrowcapital-signals';

const WatchersComponent = props => {
  // Function to get the last 7 days
  const {
    user
  } = useUserContext();
  const [lowestPrices, setLowestPrices] = useState([]);
  const [watchers, setWatchers] = useState([]);
  // Store current prices by symbol for efficient updates
  const [currentPrices, setCurrentPrices] = useState({});
  const [watchersHitStopLossPrice, setWatchersHitStopLossPrice] = useState([]);
  const [section, setSection] = useState('Active')
  const [client, setClient] = useState(null);
  const mqttClientRef = useRef(null); // holds the MQTT client instance
  const mqttListenerAttached = useRef(false); // ensures only one message handler is attached
  const wsRefBinance = useRef(null);
  const [lastUpdated, setLastUpdated] = useState(new Date().valueOf());
  const [isProcessing, setIsProcessing] = useState(false)


  //connect and subscribe to MQTT broker
  const _connectMQTT = useCallback(async (props) => {
    if (mqttClientRef.current) return; // already connected
    let clientID = 'GoldenSparrowCapital-' + user.user_uuid;
    const gsccookie = Cookies.get('gsccookie') || null;
    const newClient = mqtt.connect(process.env.REACT_APP_EXTERNAL_MQTT_SERVER_URL, {
      clientId: clientID,
      username: 'user-jwt',
      password: gsccookie,
      clean: true,
      rejectUnauthorized: true,
      reconnectPeriod: 60000,
    });
    mqttClientRef.current = newClient;
    setClient(newClient);

    newClient.on('connect', async () => {
      console.log('Connected to MQTT:', new Date().toLocaleTimeString());
      //many a times the following GET_WATCHERS is published multiple times, which creates a problem
      //can u fix
      //how will the following fix it ?

      const publishGetWatchers = () => {
        newClient.publish("GET_WATCHERS", JSON.stringify({ token: gsccookie }), err => {
          if (!err) {
            setIsProcessing(true)
            console.log('GET_WATCHERS request published:', new Date().toLocaleTimeString());
          } else {
            console.error('Topic Publish error', err);
          }
        });
      };

      publishGetWatchers();

      // const publishGetLowestPrices = () => {
      //   newClient.publish("GET_LOWESTPRICES", JSON.stringify({ token: gsccookie }), err => {
      //     if (!err) {
      //       console.log('GET_LOWESTPRICES request published:', new Date().toLocaleTimeString());
      //     } else {
      //       console.error('Topic Publish error', err);
      //     }
      //   });
      // };

      // publishGetLowestPrices();

      [
        'RECEIVE_WATCHERS_WEB',
        'ADD_WATCHER',
        'UPDATE_WATCHER',
        'DELETE_WATCHER',
        'ADD_Watcher_To_StopLoss',
        'RECEIVE_LOWESTPRICES',
      ].forEach(topic => {
        newClient.unsubscribe(topic);
        newClient.subscribe(topic, err => {
          if (err) {
            console.error('Topic Subscribe error', err);
          }
        });
      });
    });
  }, [setClient, setIsProcessing]);


  useEffect(() => {
    if (!client || mqttListenerAttached.current) return;
    const handler = (topic, message) => {
      // console.log('Received message:', topic, new Date().toLocaleTimeString());
      if (topic === 'ADD_WATCHER') {
        let mm = JSON.parse(message);
        setWatchers(prev => [...prev, mm.watcher]);
        setLastUpdated(new Date().valueOf());
      }
      if (topic === 'RECEIVE_WATCHERS_WEB') {
        setIsProcessing(false);
        let ww = JSON.parse(message);
        let watchers = ww.watchers;
        setWatchers(watchers);
        setLastUpdated(new Date().valueOf());
        // Reset prices for new watcher list
        setCurrentPrices({});
      }
      if (topic === 'UPDATE_WATCHER') {
        let obj = JSON.parse(message);
        let newWatcher = obj.watcher;
        // Only update the price for the relevant symbol
        setCurrentPrices(prev => {
          if (!newWatcher.symbol || newWatcher.currentPrice === undefined) return prev;
          const newPrice = Number(newWatcher.currentPrice).toFixed(newWatcher.numberOfDecimalValues);
          if (prev[newWatcher.symbol] === newPrice) return prev;
          return { ...prev, [newWatcher.symbol]: newPrice };
        });
        // Also update other watcher fields if needed
        setWatchers(prev => {
          const index = prev.findIndex(item => item.symbol === newWatcher.symbol && item.uuid === newWatcher.uuid);
          if (index !== -1) {
            const updatedItem = {
              ...prev[index],
              limitPriceHit: newWatcher.limitPriceHit,
              limitPriceHitDateTime: newWatcher.limitPriceHitDateTime,
              stopLossHit: newWatcher.stopLossHit,
              minPriceAfterSignal: newWatcher.limitPriceHit === "Y" && newWatcher.stopLossHit === "N" ? newWatcher.minPriceAfterSignal : newWatcher.limitPrice,
              maxPriceAfterLimitPriceHit: newWatcher.limitPriceHit === "Y" && newWatcher.stopLossHit === "N" ? newWatcher.maxPriceAfterLimitPriceHit : newWatcher.limitPrice,
            };
            return [
              ...prev.slice(0, index),
              updatedItem,
              ...prev.slice(index + 1),
            ];
          }
          return prev;
        });
        setLastUpdated(new Date().valueOf());
      }
      if (topic === 'DELETE_WATCHER') {
        let obj = JSON.parse(message);
        setWatchers(prev => prev.filter(watcher => watcher.uuid !== obj.uuid));
      }
      if (topic === "ADD_Watcher_To_StopLoss") {
        let watcher = JSON.parse(message);
        setWatchersHitStopLossPrice(prev => [...prev, watcher]);
      }
      if (topic === "RECEIVE_LOWESTPRICES") {
        let prices = JSON.parse(message);
        setLowestPrices(prices.lowestPrices);
      }
    };
    client.on('message', handler);
    mqttListenerAttached.current = true;
    return () => {
      if (mqttClientRef.current) {
        mqttClientRef.current.end();
        mqttClientRef.current = null;
        setClient(null);
        mqttListenerAttached.current = false;
      }
    };
  }, [client, setIsProcessing]);

  useEffect(() => {
    _connectMQTT(props);
    // eslint-disable-next-line
  }, []);



  // useEffect(() => {
  //   const intervalId = setInterval(
  //     () => {
  //       subscribeToSymbols(watchers);
  //     },
  //     1 * 60 * 1000
  //   ); // every 1 minute
  //   // Clean up the interval when the component unmounts
  //   return () => clearInterval(intervalId);
  // }, []);

  // Function to subscribe to real-time Binance prices
  // const subscribeToSymbols = useCallback((ww) => {
  //   unsubscribeFromSymbols();

  //   let symBolsToSubscribe = ww.filter(
  //     watcher =>
  //       (watcher.limitPriceHit == 'N' && watcher.stopLossHit == 'N') ||
  //       (watcher.limitPriceHit == 'Y' && watcher.stopLossHit == 'N')
  //   );

  //   console.log("Subscribing to symbols:", symBolsToSubscribe.length, new Date().toLocaleTimeString());

  //   const streams = symBolsToSubscribe.map(w => `${w.symbol.toLowerCase()}@ticker`).join('/');
  //   const url = `wss://stream.binance.com:9443/stream?streams=${streams}`;

  //   wsRefBinance.current = new WebSocket(url);

  //   wsRefBinance.current.onmessage = event => {
  //     const message = JSON.parse(event.data);
  //     const { s: symbol, c: currentPrice } = message.data;

  //     setWatchers(prev =>
  //       prev.map(item =>
  //         item.symbol === symbol
  //           ? {
  //             ...item,
  //             currentPrice: Number(currentPrice).toFixed(item.numberOfDecimalValues),
  //             minPriceAfterSignal:
  //               currentPrice < item.minPriceAfterSignal ? currentPrice : item.minPriceAfterSignal,
  //             maxPriceAfterLimitPriceHit:
  //               currentPrice > item.maxPriceAfterLimitPriceHit
  //                 ? currentPrice
  //                 : item.maxPriceAfterLimitPriceHit,
  //           }
  //           : item
  //       )
  //     );

  //     // setWatchers(watchers.map(item =>
  //     //   item.symbol === symbol ? { ...item,
  //     //    currentPrice: currentPrice
  //     //    } : item
  //     // ));
  //     // let ss = [...data];
  //     // ss.forEach(watcher => {
  //     //   if (watcher.symbol === symbol.toUpperCase()) {
  //     //     watcher.currentPrice = Number(currentPrice).toFixed(watcher.numberOfDecimalValues);

  //     //   }
  //     // });

  //     // setWatchers(ss);
  //   };

  //   wsRefBinance.current.onerror = err => {
  //     // console.error("Binance WebSocket error:", err);
  //   };

  //   wsRefBinance.current.onclose = () => {
  //      wsRefBinance.current = null;
  //     // console.log("Binance WebSocket closed");
  //   };
  // });

  // Function to unsubscribe/cleanup
  // const unsubscribeFromSymbols = useCallback(() => {
  //   if (wsRefBinance.current) {
  //     wsRefBinance.current.close();
  //     wsRefBinance.current = null;
  //   }
  // }, []);


  // const getWatchers = async () => {
  //   try {
  //     const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/api/dashboard/getWatchers`, {
  //       method: 'GET',
  //       credentials: 'include',
  //       headers: {
  //         Accept: 'application/json',
  //         'Content-Type': 'application/json',
  //       },
  //     });

  //     if (!response.ok) {
  //       setWatchers([]);
  //     }

  //     const data = await response.json();

  //     // Handle the standardized response format
  //     if (data.success && Array.isArray(data.data)) {
  //       // console.log(data.data)
  //       setWatchers(data.data);
  //       subscribeToSymbols(data.data);

  //       //  return data.data; // Return the array of watchers from the data property
  //     } else {
  //       console.error('Invalid response format:', data.message || 'Unknown error');
  //       // return [];
  //     }
  //   } catch (e) {
  //     console.error('Error fetching watchers:', e);
  //     // return [];
  //   }
  // };

  const getWatchersHitStopLoss = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_SERVER_URL}/api/dashboard/getWatchersHitStopLoss`,
        {
          method: 'GET',
          credentials: 'include',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
        }
      );

      if (!response.ok) {
        setWatchersHitStopLossPrice([]);
      }
      const data = await response.json();

      // Handle the standardized response format
      if (data.success && Array.isArray(data.data)) {
        // console.log(data.data)
        setWatchersHitStopLossPrice(data.data);
      } else {
        console.error('Invalid response format:', data.message || 'Unknown error');
        // return [];
      }
    } catch (e) {
      console.error('Error fetching watchers:', e);
      // return [];
    }
  };

  // Prevent duplicate delete requests for the same watcher
  const deletingRef = useRef({});
  async function handleDelete(uuid) {
    if (deletingRef.current[uuid]) return; // Already deleting
    deletingRef.current[uuid] = true;
    setWatchers(prevWatchers => prevWatchers.filter(watcher => watcher.uuid !== uuid));
    const gsccookie = Cookies.get('gsccookie') || null;
    console.log("Deleting Watcher:", uuid)
    client.publish("DELETE_WATCHER", JSON.stringify({ token: gsccookie, uuid }), err => {
      if (err) {
        console.error('Topic Publish error', err);
      }
      // Optionally clear the lock after a delay if you want to allow retry
      setTimeout(() => { deletingRef.current[uuid] = false; }, 5000);
    });
  }

  // Memoize watchers with current prices for rendering
  const watchersWithPrices = React.useMemo(() => {
    return watchers.map(watcher => {
      const price = currentPrices[watcher.symbol] || watcher.currentPrice;
      return { ...watcher, currentPrice: price };
    });
  }, [watchers, currentPrices]);

  return watchers ? (
    <div style={{ borderRadius: 8, width: 'auto' }}>
      {/* <h6 style={{ margin: 3, textAlign : "right", fontSize : 12 }}>Count: {watchers.length}</h6> */}
      {/* <h1 className="text-sm font-normal">{props.user.email + ',' + props.user.userType}</h1> */}
      <h1 className="text-xs" style={{ margin: 0, paddingTop: 1, color: 'gray' }}> Last Updated: {new Date(lastUpdated).toLocaleDateString()} ,{' '}
        {new Date(lastUpdated).toLocaleTimeString()}
      </h1>
      <div style={{ marginTop: 5, display: 'flex', gap: 3, alignItems: "center" }}>
        <button
          style={{
            backgroundColor: section == "Active" ? '#fff' : "gray",
            color: section == "Active" ? "#282828" : "#fff",
            borderTopRightRadius: 8,
            borderTopLeftRadius: 8,
            padding: 6,
            fontSize: 14
          }}
          onClick={() => {
            setSection('Active')

          }}
        >
          Active (
          {
            watchers.filter(watcher => watcher.limitPriceHit == 'Y' && watcher.stopLossHit == 'N')
              .length
          }
          )
        </button>
        <button
          style={{
            backgroundColor: section == "Waiting" ? '#fff' : "gray",
            color: section == "Waiting" ? "#282828" : "#fff",
            borderTopRightRadius: 8,
            borderTopLeftRadius: 8,
            padding: 6,
            fontSize: 14
          }}
          onClick={() => {
            setSection('Waiting')

          }
          }
        >
          Waiting (
          {
            watchers.filter(watcher => watcher.limitPriceHit == 'N' && watcher.stopLossHit == 'N')
              .length
          }
          )
        </button>
        <button
          style={{
            backgroundColor: section == "StopLossHistory" ? '#fff' : "gray",
            color: section == "StopLossHistory" ? "#282828" : "#fff",
            borderTopRightRadius: 8,
            borderTopLeftRadius: 8,
            padding: 6,
            fontSize: 14
          }}
          onClick={() => {
            {
              setSection('StopLossHistory')
              getWatchersHitStopLoss();
            }
          }
          }
        >
          Stop Loss Hit
        </button>
        {/* <button
          style={{
            backgroundColor: section == "LowestPrices" ? '#fff' : "gray",
            color: section == "LowestPrices" ? "#282828" : "#fff",
            borderTopRightRadius: 8,
            borderTopLeftRadius: 8,
            padding: 6,
            fontSize: 14
          }}
          onClick={() => {
            {
              setSection('LowestPrices')
              //         client.publish("GET_LOWESTPRICES", JSON.stringify({ token: gsccookie }), err => {
              //   if (!err) {
              //     console.log('GET_LOWESTPRICES request published:', new Date().toLocaleTimeString());
              //   } else {
              //     console.error('Topic Publish error', err);
              //   }
              // });
            }
          }
          }
        >
          Close to Lowest Price ({lowestPrices.length})
        </button> */}

      </div>
      <hr></hr>

      {/* Active */}
      {section == "Active" ? (
        <div>
          {watchersWithPrices.filter(watcher => watcher.limitPriceHit == 'Y' && watcher.stopLossHit == 'N')
            .length > 0 ? (
            <div style={{ padding: 5 }}>
              <table className="min-w-full bg-white dark:bg-gray-800 shadow-md rounded-lg">
                <thead>
                  <tr>
                    <th className="text-sm py-2 px-4 border-b">S.No.</th>
                    <th className="text-sm py-2 px-4 border-b">Creation Date & Time</th>
                    <th className="text-sm py-2 px-4 border-b">Limit Price Hit Date & Time</th>
                    <th className="text-sm py-2 px-4 border-b">Symbol, Current Price & Profit/Loss</th>
                    {props.user?.userType == 'ADMIN' ? (
                      <th className="text-sm py-2 px-4 border-b">Strategy Name</th>
                    ) : null}
                    <th className="text-sm py-2 px-4 border-b">Signal</th>
                    <th className="text-sm py-2 px-4 border-b">Limit Price</th>
                    <th className="text-sm py-2 px-4 border-b">Stop Loss Price</th>
                    <th className="text-sm py-2 px-4 border-b">Maximum Price after Limit Price Hit</th>
                    <th className="text-sm py-2 px-4 border-b">Minimum Price after Limit Price Hit</th>
                    {props.user?.userType == 'ADMIN' ? (
                      <th className="text-sm py-2 px-4 border-b">Delete</th>
                    ) : null}
                  </tr>
                </thead>
                <tbody>
                  {_.orderBy(
                    watchersWithPrices.filter(
                      watcher => watcher.limitPriceHit == 'Y' && watcher.stopLossHit == 'N'
                    ),
                    'limitPriceHitDateTime',
                    'desc'
                  ).map((watcher, index) => {
                    return (
                      <tr key={watcher.uuid}>
                        {/* S.No. */}
                        <td className="text-xs py-2 px-4 border-b text-center">
                          <h6 style={{ paddingLeft: 1 }}>{index + 1}.</h6>
                        </td>

                        {/* Creation Date & Time */}
                        <td className="text-xs py-2 px-4 border-b text-center">
                          {new Date(watcher.creationDate).toLocaleDateString() +
                            ', ' +
                            new Date(watcher.creationDate).toLocaleTimeString(undefined, {
                              hour12: true,
                            })}
                        </td>

                        {/* Limit Price Date & Time */}
                        <td className="text-xs py-2 px-4 border-b text-center">
                          {new Date(watcher?.limitPriceHitDateTime).toLocaleDateString() +
                            ', ' +
                            new Date(watcher?.limitPriceHitDateTime).toLocaleTimeString(undefined, {
                              hour12: true,
                            })}
                        </td>

                        {/* Symbol */}

                        <td className="text-xs py-2 px-4 border-b text-center">
                          <div style={{ alignItems: 'center', display: 'flex' }}>
                            <button
                              style={{
                                backgroundColor: '#0474c9',
                                fontSize: 12,
                                borderRadius: 5,
                                padding: 5,
                              }}

                              onClick={() => {
              // if (props.user?.userType == 'ADMIN') {

                              //   window.open(
                              //     'https://www.coinglass.com/tv/Binance_' + watcher.symbol,
                              //     '_blank'
                              //   )
                              // } else {
                              //   window.open(
                              //     'https://www.tradingview.com/chart/?symbol=BINANCE%3A' + watcher.symbol,
                              //     '_blank'
                              //   )
                              // }


                              }}
                            >
                              <div style={{ alignItems: 'center', display: 'flex' }}>
                                <h4 style={{ fontWeight: 'bolder', paddingLeft: 2 }}>{watcher.symbol}</h4>
                                <h6 style={{ paddingLeft: 5 }}>
                                  ${Number(watcher.currentPrice).toFixed(watcher.numberOfDecimalValues)}
                                </h6>
                                {/*
                              {watcher.limitPriceHit == 'Y' && watcher.stopLossHit == 'N' ? (
                                <h6 style={{ paddingLeft: 5 }}>
                                  (
                                  {(
                                    ((watcher.currentPrice - watcher.limitPrice) * 100) /
                                    watcher.limitPrice
                                  ).toFixed(2) + '%'}
                                  )
                                </h6>
                              ) : null} */}
                              </div>
                            </button>


                            {props.user?.userType == 'ADMIN' ?

                              <a
                                href={`https://www.coinglass.com/tv/Binance_${watcher.symbol}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{ marginLeft: 6, display: 'flex', alignItems: 'center' }}
                                title="CoinGlass"
                              >
                                <svg
                                  width="20"
                                  height="20"
                                  viewBox="0 0 32 32"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                  style={{ display: 'inline', verticalAlign: 'middle' }}
                                >
                                  {/* Dark background circle matching trading terminal themes */}
                                  <circle cx="16" cy="16" r="16" fill="#1E222D" />

                                  {/* Upward diagonal arrow symbolizing market breakouts and data shifts */}
                                  <path
                                    d="M10.5 21.5L21.5 10.5M21.5 10.5H13.5M21.5 10.5V18.5"
                                    stroke="#ffffff"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />

                                  {/* Subtle outer border for depth */}
                                  <circle cx="16" cy="16" r="15.5" stroke="#2A2E39" strokeWidth="1" />
                                </svg>
                              </a>
                              : null}
                            <a
                              href={`https://www.tradingview.com/chart/?symbol=BINANCE%3A${watcher.symbol}`}
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{ marginLeft: 6, display: 'flex', alignItems: 'center' }}
                              title="TradingView"
                            >
                              <svg
                                width="20"
                                height="20"
                                viewBox="0 0 32 32"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                                style={{ display: 'inline', verticalAlign: 'middle' }}
                              >
                                {/* Standard Terminal Background */}
                                <circle cx="16" cy="16" r="16" fill="#1E222D" />

                                {/* TradingView 'Chart' Bars - Representing Technical Analysis */}
                                <rect x="9" y="15" width="3" height="7" rx="1" fill="#ffffff" />
                                <rect x="14.5" y="10" width="3" height="12" rx="1" fill="#ffffff" />
                                <rect x="20" y="13" width="3" height="9" rx="1" fill="#ffffff" />

                                {/* Border for UI consistency */}
                                <circle cx="16" cy="16" r="15.5" stroke="#2A2E39" strokeWidth="1" />
                              </svg>
                            </a>




                            {watcher.limitPriceHit == 'Y' && watcher.stopLossHit == 'N' ? (
                              <div style={{ backgroundColor: "white", borderRadius: 5, padding: 5, marginLeft : 5 }}>
                                <h6 style={{
                                  paddingLeft: 5, color: (
                                    ((watcher.currentPrice - watcher.limitPrice) * 100) /
                                    watcher.limitPrice
                                  ).toFixed(2) > 0 ? 'green' : 'red'
                                }}>
                                  (
                                  {(
                                    ((watcher.currentPrice - watcher.limitPrice) * 100) /
                                    watcher.limitPrice
                                  ).toFixed(2) + '%'}
                                  )
                                </h6>
                              </div>
                            ) : null}
                          </div>
                        </td>

                        {/* Strategy */}
                        {/* {props.user.userType == 'ADMIN' ? ( */}
                        <td className="text-xs py-2 px-4 border-b text-center">
                          {watcher.strategyName + (watcher.timeFrame ? ' (' + watcher.timeFrame + ')' : '')}
                        </td>
                        {/* ) : null} */}

                        {/* Order Type */}
                        <td className="text-xs py-2 px-4 border-b text-center">
                          {watcher?.openingPosition}
                        </td>

                        {/* <td className="py-2 px-4 border-b text-center">
                      {watcher?.timeFrame + ' (' + watcher?.duration + ')'}
                    </td> */}

                        {/* Limit Price */}
                        <td className="text-xs py-2 px-4 border-b text-center">
                          {watcher.limitPriceHit == 'N' && watcher.stopLossHit == 'N' ? (
                            <span style={{ color: 'grey' }}>
                              ${Number(watcher.limitPrice).toFixed(watcher.numberOfDecimalValues)}
                            </span>
                          ) : null}

                          {watcher.limitPriceHit == 'Y' ? (
                            <button
                              style={{
                                fontSize: 12,
                                borderRadius: 5,
                                padding: 5,
                              }}
                            >
                              <div style={{ alignItems: 'center', display: 'flex' }}>
                                <span>
                                  ${Number(watcher.limitPrice).toFixed(watcher.numberOfDecimalValues)}
                                </span>
                                <span style={{ paddingLeft: 2 }}>
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    strokeWidth={2}
                                    stroke="green"
                                    className="size-5"
                                  >
                                    <path
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      d="M9 12l2 2 4-4M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                                    />
                                  </svg>
                                </span>
                              </div>
                            </button>
                          ) : null}

                          {watcher.limitPriceHit == 'N' && watcher.stopLossHit == 'Y' ? (
                            <span style={{ color: 'grey' }}>
                              ${Number(watcher.limitPrice).toFixed(watcher.numberOfDecimalValues)} (
                              {Number(
                                ((watcher.limitPrice - watcher?.stopLossPrice) * 100) / watcher.stopLossPrice
                              ).toFixed(2) + '%'}
                              )
                            </span>
                          ) : null}
                        </td>

                        {/* Stop Loss */}
                        <td className="text-xs py-2 px-4 border-b text-center">
                          {watcher.stopLossHit == 'N' ? (
                            <span style={{ color: 'grey' }}>
                              ${Number(watcher.stopLossPrice).toFixed(watcher.numberOfDecimalValues)} (
                              {-1 *
                                Number(
                                  ((watcher.limitPrice - watcher?.stopLossPrice) * 100) / watcher.stopLossPrice
                                ).toFixed(2) +
                                '%'}
                              )
                            </span>
                          ) : null}

                          {watcher.stopLossHit == 'Y' ? (
                            <button
                              style={{
                                borderRadius: 5,
                                fontSize: 12,

                                padding: 5,
                              }}
                            >
                              <div style={{ alignItems: 'center', display: 'flex' }}>
                                <span>
                                  ${Number(watcher?.stopLossPrice).toFixed(watcher.numberOfDecimalValues)} (
                                  {Number(
                                    ((watcher.limitPrice - watcher?.stopLossPrice) * 100) / watcher.stopLossPrice
                                  ).toFixed(2) + '%'}
                                  )
                                </span>
                                <span style={{ paddingLeft: 1 }}>
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    strokeWidth={1.5}
                                    stroke="red"
                                    className="size-5"
                                  >
                                    <path
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      d="m9.75 9.75 4.5 4.5m0-4.5-4.5 4.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                                    />
                                  </svg>
                                </span>
                              </div>
                            </button>
                          ) : null}
                        </td>

                        {/* Maximum Price & Profit */}
                        <td className="text-xs py-2 px-4 border-b text-center" style={{ color: "green" }}>
                          {watcher.limitPriceHit == 'Y' ? (
                            <>
                              $
                              {Number(watcher?.maxPriceAfterLimitPriceHit).toFixed(
                                watcher.numberOfDecimalValues
                              )}{' '}
                              (
                              {Number(
                                ((watcher.maxPriceAfterLimitPriceHit - watcher.limitPrice) * 100) /
                                watcher.limitPrice
                              ).toFixed(2) + '%'}
                              )
                            </>
                          ) : null}
                        </td>

                        {/* Minimum Price & Profit */}
                        <td className="text-xs py-2 px-4 border-b text-center" style={{ color: "red" }}>
                          {watcher.limitPriceHit == 'Y' ? (
                            <>
                              $
                              {Number(watcher?.minPriceAfterSignal).toFixed(
                                watcher.numberOfDecimalValues
                              )} (
                              {-1 *
                                Number(
                                  ((watcher.limitPrice - watcher?.minPriceAfterSignal) * 100) / watcher.minPriceAfterSignal
                                ).toFixed(2) +
                                '%'}
                              )
                            </>
                          ) : null}
                        </td>

                        {/* Delete Button */}
                        <td className="py-2 px-4 border-b">
                          <div style={{ textAlign: 'center' }}>
                            <button
                              style={{
                                // backgroundColor: '#00ff00',

                                padding: 5,
                              }}
                              onClick={() => handleDelete(watcher.uuid)}
                            >
                              {/* <h4 style={{ fontWeight: 'bolder', paddingLeft: 2 }}>Delete</h4> */}
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 24 24"
                                fill="currentColor"
                                className="size-4"
                              >
                                <path
                                  fillRule="evenodd"
                                  d="M16.5 4.478v.227a48.816 48.816 0 0 1 3.878.512.75.75 0 1 1-.256 1.478l-.209-.035-1.005 13.07a3 3 0 0 1-2.991 2.77H8.084a3 3 0 0 1-2.991-2.77L4.087 6.66l-.209.035a.75.75 0 0 1-.256-1.478A48.567 48.567 0 0 1 7.5 4.705v-.227c0-1.564 1.213-2.9 2.816-2.951a52.662 52.662 0 0 1 3.369 0c1.603.051 2.815 1.387 2.815 2.951Zm-6.136-1.452a51.196 51.196 0 0 1 3.273 0C14.39 3.05 15 3.684 15 4.478v.113a49.488 49.488 0 0 0-6 0v-.113c0-.794.609-1.428 1.364-1.452Zm-.355 5.945a.75.75 0 1 0-1.5.058l.347 9a.75.75 0 1 0 1.499-.058l-.346-9Zm5.48.058a.75.75 0 1 0-1.498-.058l-.347 9a.75.75 0 0 0 1.5.058l.345-9Z"
                                  clipRule="evenodd"
                                />
                              </svg>
                            </button>
                          </div>
                        </td>
                      </tr>
                    );
                    // }
                  })}
                </tbody>
              </table>
              <h6 style={{ margin: 0, padding: 5, color: 'gray', fontSize: 12 }}>
                *Note: Signals will be removed automatically after 7 days.
              </h6>
            </div>
          ) : (
            <div style={{ padding: 5 }}>
              <h5 style={{ margin: 0, padding: 0, color: 'red', fontSize: 12 }}>No signals.</h5>
            </div>
          )}
        </div>
      ) : null}

      {/* Waiting */}
      {section == "Waiting" ? (
        <div>
          {watchersWithPrices.filter(watcher => watcher.limitPriceHit == 'N' && watcher.stopLossHit == 'N')
            .length > 0 ? (
            <div style={{ padding: 5 }}>
              <table className="min-w-full bg-white dark:bg-gray-800 shadow-md rounded-lg">
                <thead>
                  <tr>
                    <th className="text-sm py-2 px-4 border-b">S.No.</th>
                    <th className="text-sm py-2 px-4 border-b">Creation Date & Time</th>
                    <th className="text-sm py-2 px-4 border-b">Symbol & Current Price</th>
                    {props.user.userType == 'ADMIN' ? (
                      <th className="text-sm py-2 px-4 border-b">Strategy Name</th>
                    ) : null}
                    <th className="text-sm py-2 px-4 border-b">Signal</th>
                    <th className="text-sm py-2 px-4 border-b">Limit Price</th>
                    <th className="text-sm py-2 px-4 border-b">Stop Loss  Price</th>
                    {props.user.userType == 'ADMIN' ? (
                      <th className="text-sm py-2 px-4 border-b">Delete</th>
                    ) : null}
                  </tr>
                </thead>
                <tbody>
                  {_.orderBy(
                    watchersWithPrices.filter(
                      watcher => watcher.limitPriceHit == 'N' && watcher.stopLossHit == 'N'
                    ),
                    'creationDate',
                    'desc'
                  ).map((watcher, index) => {
                    return (
                      <tr key={watcher.uuid}>
                        {/* S.No */}
                        <td className="text-xs py-2 px-4 border-b text-center">
                          <h6 style={{ paddingLeft: 1 }}>{index + 1}.</h6>
                        </td>

                        {/* Date & Time */}
                        <td className="text-xs py-2 px-4 border-b text-center">
                          {new Date(watcher.creationDate).toLocaleDateString() +
                            ', ' +
                            new Date(watcher.creationDate).toLocaleTimeString(undefined, {
                              hour12: true,
                            })}
                        </td>

                        {/* Symbol */}
                        <td className="py-2 px-4 border-b">
                           <div style={{ alignItems: 'center', display: 'flex' }}>
                         
                          <button
                            style={{
                              backgroundColor: '#0474c9',
                              fontSize: 12,
                              borderRadius: 5,
                              padding: 5,
                            }}
                            // target="_blank"
                            // variant="contained"
                            // endIcon={<OpenInNewIcon fontSize="small" />}
                            // size="small"
                            // href={
                            //   "https://www.tradingview.com/chart/?symbol=BINANCE%3A" +
                            //   watcher.symbol
                            // }
                            onClick={() => {
                              // if (props.user?.userType == 'ADMIN') {

                              //   window.open(
                              //     'https://www.coinglass.com/tv/Binance_' + watcher.symbol,
                              //     '_blank'
                              //   )
                              // } else {
                              //   window.open(
                              //     'https://www.tradingview.com/chart/?symbol=BINANCE%3A' + watcher.symbol,
                              //     '_blank'
                              //   )
                              // }
                            }
                            }
                          >
                            <div style={{ alignItems: 'center', display: 'flex' }}>
                              <h4 style={{ fontWeight: 'bolder', paddingLeft: 2 }}>{watcher.symbol}</h4>

                              <h6 style={{ paddingLeft: 5 }}>
                                ${Number(watcher.currentPrice).toFixed(watcher.numberOfDecimalValues)}
                              </h6>
                             
                            </div>
                          </button>
                           {props.user?.userType == 'ADMIN' ?

                              <a
                                href={`https://www.coinglass.com/tv/Binance_${watcher.symbol}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{ marginLeft: 6, display: 'flex', alignItems: 'center' }}
                                title="CoinGlass"
                              >
                                <svg
                                  width="20"
                                  height="20"
                                  viewBox="0 0 32 32"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                  style={{ display: 'inline', verticalAlign: 'middle' }}
                                >
                                  {/* Dark background circle matching trading terminal themes */}
                                  <circle cx="16" cy="16" r="16" fill="#1E222D" />

                                  {/* Upward diagonal arrow symbolizing market breakouts and data shifts */}
                                  <path
                                    d="M10.5 21.5L21.5 10.5M21.5 10.5H13.5M21.5 10.5V18.5"
                                    stroke="#ffffff"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />

                                  {/* Subtle outer border for depth */}
                                  <circle cx="16" cy="16" r="15.5" stroke="#2A2E39" strokeWidth="1" />
                                </svg>
                              </a>
                              : null}
                            <a
                              href={`https://www.tradingview.com/chart/?symbol=BINANCE%3A${watcher.symbol}`}
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{ marginLeft: 6, display: 'flex', alignItems: 'center' }}
                              title="TradingView"
                            >
                              <svg
                                width="20"
                                height="20"
                                viewBox="0 0 32 32"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                                style={{ display: 'inline', verticalAlign: 'middle' }}
                              >
                                {/* Standard Terminal Background */}
                                <circle cx="16" cy="16" r="16" fill="#1E222D" />

                                {/* TradingView 'Chart' Bars - Representing Technical Analysis */}
                                <rect x="9" y="15" width="3" height="7" rx="1" fill="#ffffff" />
                                <rect x="14.5" y="10" width="3" height="12" rx="1" fill="#ffffff" />
                                <rect x="20" y="13" width="3" height="9" rx="1" fill="#ffffff" />

                                {/* Border for UI consistency */}
                                <circle cx="16" cy="16" r="15.5" stroke="#2A2E39" strokeWidth="1" />
                              </svg>
                            </a>
                            </div>
                        </td>

                        

                        {/* Strategy Name */}
                        {props.user.userType == 'ADMIN' ? (
                          <td className="text-xs py-2 px-4 border-b text-center">
                            {watcher.strategyName + (watcher.timeFrame ? ' (' + watcher.timeFrame + ')' : '')}
                          </td>
                        ) : null}

                        {/* Order Type */}
                        <td className="text-xs py-2 px-4 border-b text-center">
                          {watcher?.openingPosition}
                        </td>
                        {/* <td className="py-2 px-4 border-b text-center">
                      {watcher?.timeFrame + ' (' + watcher?.duration + ')'}
                    </td> */}

                        {/* Limit Price */}
                        <td className="text-xs py-2 px-4 border-b text-center">
                          {watcher.limitPriceHit == 'N' && watcher.stopLossHit == 'N' ? (
                            <span style={{ color: 'grey' }}>
                              ${Number(watcher.limitPrice).toFixed(watcher.numberOfDecimalValues)}
                            </span>
                          ) : null}

                          {watcher.limitPriceHit == 'Y' ? (
                            <button
                              style={{
                                fontSize: 12,
                                borderRadius: 5,
                                padding: 5,
                              }}
                            >
                              <div style={{ alignItems: 'center', display: 'flex' }}>
                                <span>
                                  ${Number(watcher.limitPrice).toFixed(watcher.numberOfDecimalValues)}
                                </span>
                                <span style={{ paddingLeft: 2 }}>
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    strokeWidth={2}
                                    stroke="green"
                                    className="size-5"
                                  >
                                    <path
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      d="M9 12l2 2 4-4M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                                    />
                                  </svg>
                                </span>
                              </div>
                            </button>
                          ) : null}

                          {watcher.limitPriceHit == 'N' && watcher.stopLossHit == 'Y' ? (
                            <span style={{ color: 'grey' }}>
                              ${Number(watcher.limitPrice).toFixed(watcher.numberOfDecimalValues)}
                            </span>
                          ) : null}
                        </td>

                        {/* Stop Loss */}
                        <td className="text-xs py-2 px-4 border-b text-center">
                          {watcher.stopLossHit == 'N' ? (
                            <span style={{ color: 'grey' }}>
                              ${Number(watcher.stopLossPrice).toFixed(watcher.numberOfDecimalValues)} (
                              {-1 *
                                Number(
                                  ((watcher.limitPrice - watcher?.stopLossPrice) * 100) / watcher.stopLossPrice
                                ).toFixed(2) +
                                '%'}
                              )
                            </span>
                          ) : null}

                          {watcher.stopLossHit == 'Y' ? (
                            <button
                              style={{
                                borderRadius: 5,
                                fontSize: 12,

                                padding: 5,
                              }}
                            >
                              <div style={{ alignItems: 'center', display: 'flex' }}>
                                <span>
                                  ${Number(watcher?.stopLossPrice).toFixed(watcher.numberOfDecimalValues)} (
                                  {Number(
                                    ((watcher.limitPrice - watcher?.stopLossPrice) * 100) / watcher.stopLossPrice
                                  ).toFixed(2) + '%'}
                                  )
                                </span>
                                <span style={{ paddingLeft: 1 }}>
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    strokeWidth={1.5}
                                    stroke="red"
                                    className="size-5"
                                  >
                                    <path
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      d="m9.75 9.75 4.5 4.5m0-4.5-4.5 4.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                                    />
                                  </svg>
                                </span>
                              </div>
                            </button>
                          ) : null}
                        </td>

                        {/* Delete Button */}
                        <td className="py-2 px-4 border-b">
                          <div style={{ textAlign: 'center' }}>
                            <button
                              style={{
                                // backgroundColor: '#00ff00',

                                padding: 5,
                              }}
                              onClick={() => handleDelete(watcher.uuid)}
                            >
                              {/* <h4 style={{ fontWeight: 'bolder', paddingLeft: 2 }}>Delete</h4> */}
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 24 24"
                                fill="currentColor"
                                className="size-4"
                              >
                                <path
                                  fillRule="evenodd"
                                  d="M16.5 4.478v.227a48.816 48.816 0 0 1 3.878.512.75.75 0 1 1-.256 1.478l-.209-.035-1.005 13.07a3 3 0 0 1-2.991 2.77H8.084a3 3 0 0 1-2.991-2.77L4.087 6.66l-.209.035a.75.75 0 0 1-.256-1.478A48.567 48.567 0 0 1 7.5 4.705v-.227c0-1.564 1.213-2.9 2.816-2.951a52.662 52.662 0 0 1 3.369 0c1.603.051 2.815 1.387 2.815 2.951Zm-6.136-1.452a51.196 51.196 0 0 1 3.273 0C14.39 3.05 15 3.684 15 4.478v.113a49.488 49.488 0 0 0-6 0v-.113c0-.794.609-1.428 1.364-1.452Zm-.355 5.945a.75.75 0 1 0-1.5.058l.347 9a.75.75 0 1 0 1.499-.058l-.346-9Zm5.48.058a.75.75 0 1 0-1.498-.058l-.347 9a.75.75 0 0 0 1.5.058l.345-9Z"
                                  clipRule="evenodd"
                                />
                              </svg>
                            </button>
                          </div>
                        </td>
                      </tr>
                    );
                    // }
                  })}
                </tbody>
              </table>
              <h6 style={{ margin: 0, padding: 5, color: 'gray', fontSize: 12 }}>
                *Note: Signals will be removed automatically after 7 days.
              </h6>
            </div>
          ) : (
            <div style={{ padding: 5 }}>
              <h5 style={{ margin: 0, padding: 0, color: 'red', fontSize: 12 }}>No signals.</h5>
            </div>

          )}
        </div>
      ) : null}

      {/* Stop Loss */}
      {section == "StopLossHistory" ? (
        <div>
          {watchersHitStopLossPrice.length > 0 ? (
            <div style={{ padding: 5 }}>
              <table className="min-w-full bg-white dark:bg-gray-800 shadow-md rounded-lg">
                <thead>
                  <tr>
                    <th className="text-sm py-2 px-4 border-b">S.No.</th>
                    <th className="text-sm py-2 px-4 border-b">Date & Time</th>
                    <th className="text-sm py-2 px-4 border-b">Stop Loss Hit Date & Time</th>

                    <th className="text-sm py-2 px-4 border-b">Symbol</th>

                    {props.user.userType == 'ADMIN' ? (
                      <th className="text-sm py-2 px-4 border-b">Strategy Name</th>
                    ) : null}
                    <th className="text-sm py-2 px-4 border-b">Signal</th>
                    {/* <th className="text-sm py-2 px-4 border-b">Timeframe & Duration</th> */}

                    <th className="text-sm py-2 px-4 border-b">Limit Price</th>
                    <th className="text-sm py-2 px-4 border-b">Stop Loss Price</th>

                    <th className="text-sm py-2 px-4 border-b">Maximum Price</th>
                    <th className="text-sm py-2 px-4 border-b">Minimum Price</th>

                    {props.user.userType == 'ADMIN' ? (
                      <th className="text-sm py-2 px-4 border-b">Delete</th>
                    ) : null}

                    {/* <th className="text-sm py-2 px-4 border-b">Maximum Loss</th> */}
                  </tr>
                </thead>

                <tbody>
                  {_.orderBy(
                    watchersHitStopLossPrice,
                    'stopLossHitDateTime',
                    'desc'
                  ).map((watcher, index) => {

                    return (
                      <tr key={watcher.uuid}>
                        {/* S.No */}
                        <td className="text-xs py-2 px-4 border-b text-center">
                          <h6 style={{ paddingLeft: 1 }}>{index + 1}.</h6>
                        </td>

                        {/* Date & Time */}
                        <td className="text-xs py-2 px-4 border-b text-center">
                          {new Date(watcher.creationDate).toLocaleDateString() +
                            ', ' +
                            new Date(watcher.creationDate).toLocaleTimeString(undefined, {
                              hour12: true,
                            })}
                        </td>
                        {/* Stop Loss HIt Date & Time */}
                        <td className="text-xs py-2 px-4 border-b text-center">
                          {new Date(watcher?.stopLossHitDateTime).toLocaleDateString() +
                            ', ' +
                            new Date(watcher?.stopLossHitDateTime).toLocaleTimeString(undefined, {
                              hour12: true,
                            })}
                        </td>

                        {/* Symbol */}
                       <td className="py-2 px-4 border-b">
                           <div style={{ alignItems: 'center', display: 'flex' }}>
                         
                          <button
                            style={{
                              backgroundColor: '#0474c9',
                              fontSize: 12,
                              borderRadius: 5,
                              padding: 5,
                            }}
                            // target="_blank"
                            // variant="contained"
                            // endIcon={<OpenInNewIcon fontSize="small" />}
                            // size="small"
                            // href={
                            //   "https://www.tradingview.com/chart/?symbol=BINANCE%3A" +
                            //   watcher.symbol
                            // }
                            onClick={() => {
                              // if (props.user?.userType == 'ADMIN') {

                              //   window.open(
                              //     'https://www.coinglass.com/tv/Binance_' + watcher.symbol,
                              //     '_blank'
                              //   )
                              // } else {
                              //   window.open(
                              //     'https://www.tradingview.com/chart/?symbol=BINANCE%3A' + watcher.symbol,
                              //     '_blank'
                              //   )
                              // }
                            }
                            }
                          >
                            <div style={{ alignItems: 'center', display: 'flex' }}>
                              <h4 style={{ fontWeight: 'bolder', paddingLeft: 2 }}>{watcher.symbol}</h4>

                            
                            </div>
                          </button>
                           {props.user?.userType == 'ADMIN' ?

                              <a
                                href={`https://www.coinglass.com/tv/Binance_${watcher.symbol}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{ marginLeft: 6, display: 'flex', alignItems: 'center' }}
                                title="CoinGlass"
                              >
                                <svg
                                  width="20"
                                  height="20"
                                  viewBox="0 0 32 32"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                  style={{ display: 'inline', verticalAlign: 'middle' }}
                                >
                                  {/* Dark background circle matching trading terminal themes */}
                                  <circle cx="16" cy="16" r="16" fill="#1E222D" />

                                  {/* Upward diagonal arrow symbolizing market breakouts and data shifts */}
                                  <path
                                    d="M10.5 21.5L21.5 10.5M21.5 10.5H13.5M21.5 10.5V18.5"
                                    stroke="#ffffff"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />

                                  {/* Subtle outer border for depth */}
                                  <circle cx="16" cy="16" r="15.5" stroke="#2A2E39" strokeWidth="1" />
                                </svg>
                              </a>
                              : null}
                            <a
                              href={`https://www.tradingview.com/chart/?symbol=BINANCE%3A${watcher.symbol}`}
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{ marginLeft: 6, display: 'flex', alignItems: 'center' }}
                              title="TradingView"
                            >
                              <svg
                                width="20"
                                height="20"
                                viewBox="0 0 32 32"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                                style={{ display: 'inline', verticalAlign: 'middle' }}
                              >
                                {/* Standard Terminal Background */}
                                <circle cx="16" cy="16" r="16" fill="#1E222D" />

                                {/* TradingView 'Chart' Bars - Representing Technical Analysis */}
                                <rect x="9" y="15" width="3" height="7" rx="1" fill="#ffffff" />
                                <rect x="14.5" y="10" width="3" height="12" rx="1" fill="#ffffff" />
                                <rect x="20" y="13" width="3" height="9" rx="1" fill="#ffffff" />

                                {/* Border for UI consistency */}
                                <circle cx="16" cy="16" r="15.5" stroke="#2A2E39" strokeWidth="1" />
                              </svg>
                            </a>
                            </div>
                        </td>

                        {/* Strategy Name */}
                        {props.user.userType == 'ADMIN' ? (
                          <td className="text-xs py-2 px-4 border-b text-center">
                            {watcher.strategyName + (watcher.timeFrame ? ' (' + watcher.timeFrame + ')' : '')}
                          </td>
                        ) : null}

                        {/* Order Type */}
                        <td className="text-xs py-2 px-4 border-b text-center">
                          {watcher?.openingPosition}
                        </td>
                        {/* <td className="py-2 px-4 border-b text-center">
                      {watcher?.timeFrame + ' (' + watcher?.duration + ')'}
                    </td> */}

                        {/* Limit Price */}
                        <td
                          className="text-xs py-2 px-4 border-b text-center"
                          style={{ color: 'grey' }}
                        >
                          {watcher.limitPriceHit == 'N' && watcher.stopLossHit == 'N' ? (
                            <span style={{ color: 'grey' }}>
                              ${Number(watcher.limitPrice).toFixed(watcher.numberOfDecimalValues)}
                            </span>
                          ) : null}

                          {watcher.limitPriceHit == 'Y' ? (
                            <button
                              style={{
                                fontSize: 12,
                                borderRadius: 5,
                                padding: 5,
                              }}
                            >
                              <div style={{ alignItems: 'center', display: 'flex' }}>
                                <span>
                                  ${Number(watcher.limitPrice).toFixed(watcher.numberOfDecimalValues)}
                                </span>
                                <span style={{ paddingLeft: 2 }}>
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    strokeWidth={2}
                                    stroke="green"
                                    className="size-5"
                                  >
                                    <path
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      d="M9 12l2 2 4-4M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                                    />
                                  </svg>
                                </span>
                              </div>
                            </button>
                          ) : null}

                          {watcher.limitPriceHit == 'N' && watcher.stopLossHit == 'Y' ? (
                            <span style={{ color: 'grey' }}>
                              ${Number(watcher.limitPrice).toFixed(watcher.numberOfDecimalValues)}
                            </span>
                          ) : null}
                        </td>

                        {/* Stop Loss */}
                        <td className="text-xs py-2 px-4 border-b text-center">
                          {/* {watcher.stopLossHit == 'N' ? (
                            <span style={{ color: 'grey' }}>
                              ${Number(watcher.stopLossPrice).toFixed(watcher.numberOfDecimalValues)}
                            </span>
                          ) : null} */}

                          {watcher.stopLossHit == 'Y' ? (
                           
                              <div style={{ alignItems: 'center', display: 'flex' }}>
                                <span  style={{ color: 'grey' }}>
                                  ${Number(watcher?.stopLossPrice).toFixed(watcher.numberOfDecimalValues)} (
                                  {-1 *
                                    Number(
                                      ((watcher.limitPrice - watcher?.stopLossPrice) * 100) /
                                      watcher.stopLossPrice
                                    ).toFixed(2) +
                                    '%'}
                                  )
                                </span>
                                <span style={{ paddingLeft: 1 }}>
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    strokeWidth={1.5}
                                    stroke="red"
                                    className="size-5"
                                  >
                                    <path
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      d="m9.75 9.75 4.5 4.5m0-4.5-4.5 4.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                                    />
                                  </svg>
                                </span>
                              </div>
                     
                          ) : null}
                        </td>

                        {/* Maximum Price & Profit */}
                        <td
                          className="text-xs py-2 px-4 border-b text-center"
                          style={{ color: Number(
                                ((watcher.maxPriceAfterLimitPriceHit - watcher.limitPrice) * 100) /
                                watcher.limitPrice
                              ).toFixed(2) > 1 ? "green" : "grey" }}
                        >
                          {watcher.limitPriceHit == 'Y' ? (
                            <>
                              $
                              {Number(watcher?.maxPriceAfterLimitPriceHit).toFixed(
                                watcher.numberOfDecimalValues
                              )}{' '}
                              (
                              {Number(
                                ((watcher.maxPriceAfterLimitPriceHit - watcher.limitPrice) * 100) /
                                watcher.limitPrice
                              ).toFixed(2) + '%'}
                              )
                            </>
                          ) : null}
                        </td>

                        {/* Minimum Price */}
                        <td
                          className="text-xs py-2 px-4 border-b text-center"
                          style={{ color: Number(
                                ((watcher.maxPriceAfterLimitPriceHit - watcher.limitPrice) * 100) /
                                watcher.limitPrice
                              ).toFixed(2) < 1 ? "red" : "grey" }}
                        >
                          {watcher.limitPriceHit == 'Y' ? (
                            <>
                              $
                              {Number(watcher?.minPriceAfterSignal).toFixed(
                                watcher.numberOfDecimalValues
                              )}
                            </>
                          ) : null}
                        </td>

                        {/* Delete Button */}
                        <td className="py-2 px-4 border-b">
                          <div style={{ textAlign: 'center' }}>
                            <button
                              style={{
                                // backgroundColor: '#00ff00',

                                padding: 5,
                              }}
                              onClick={() => handleDelete(watcher.uuid)}
                            >
                              {/* <h4 style={{ fontWeight: 'bolder', paddingLeft: 2 }}>Delete</h4> */}
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 24 24"
                                fill="currentColor"
                                className="size-4"
                              >
                                <path
                                  fillRule="evenodd"
                                  d="M16.5 4.478v.227a48.816 48.816 0 0 1 3.878.512.75.75 0 1 1-.256 1.478l-.209-.035-1.005 13.07a3 3 0 0 1-2.991 2.77H8.084a3 3 0 0 1-2.991-2.77L4.087 6.66l-.209.035a.75.75 0 0 1-.256-1.478A48.567 48.567 0 0 1 7.5 4.705v-.227c0-1.564 1.213-2.9 2.816-2.951a52.662 52.662 0 0 1 3.369 0c1.603.051 2.815 1.387 2.815 2.951Zm-6.136-1.452a51.196 51.196 0 0 1 3.273 0C14.39 3.05 15 3.684 15 4.478v.113a49.488 49.488 0 0 0-6 0v-.113c0-.794.609-1.428 1.364-1.452Zm-.355 5.945a.75.75 0 1 0-1.5.058l.347 9a.75.75 0 1 0 1.499-.058l-.346-9Zm5.48.058a.75.75 0 1 0-1.498-.058l-.347 9a.75.75 0 0 0 1.5.058l.345-9Z"
                                  clipRule="evenodd"
                                />
                              </svg>
                            </button>
                          </div>
                        </td>
                      </tr>
                    );

                  })}
                </tbody>
              </table>
              <h6 style={{ margin: 0, padding: 5, color: 'gray', fontSize: 12 }}>
                *Note: Signals will be removed automatically after 7 days.
              </h6>
            </div>
          ) : (
            <div style={{ padding: 5 }}>
              <h5 style={{ margin: 0, padding: 0, color: 'red', fontSize: 12 }}>No signals.</h5>
            </div>
          )}
        </div>
      ) : null}

      {/* Lowest Prices Hit */}
      {/* {section == "LowestPrices" ? (
        <div>
          {lowestPrices.length > 0 ? (
            <table className="min-w-full">
              <thead>
                <tr>
                  <th className="text-sm py-2 px-4 border-b">S.No.</th>
                  <th className="text-sm py-2 px-4 border-b">Last Updated</th>
                  <th className="text-sm py-2 px-4 border-b">Symbol</th>
                  <th className="text-sm py-2 px-4 border-b">Lowest Price</th>

                </tr>
              </thead>
              <tbody>
                {_.orderBy(lowestPrices, ['lastUpdated'], ['desc']).map((hit, index) => (
                  <tr key={index}>
                
                    <td className="text-xs py-2 px-4 border-b text-center">
                      <h6 style={{ paddingLeft: 1 }}>{index + 1}.</h6>
                    </td>
                    <td className="text-xs py-2 px-4 border-b text-center"> {new Date(hit.lastUpdated).toLocaleDateString() +
                      ', ' +
                      new Date(hit.lastUpdated).toLocaleTimeString(undefined, {
                        hour12: true,
                      })}</td>
               
                    <td className="text-xs py-2 px-4 border-b text-center">
                      <button
                        style={{
                          backgroundColor: '#0474c9',
                          fontSize: 12,
                          borderRadius: 5,
                          padding: 5,
                        }}
                        onClick={() => {
                          if (props.user?.userType == 'ADMIN') {

                            window.open(
                              'https://www.coinglass.com/tv/Binance_' + watcher.symbol,
                              '_blank'
                            )
                          } else {
                            window.open(
                              'https://www.tradingview.com/chart/?symbol=BINANCE%3A' + watcher.symbol,
                              '_blank'
                            )
                          }
                        }
                        }
                      >
                        <div style={{ alignItems: 'center', display: 'flex' }}>
                          <h4 style={{ fontWeight: 'bolder', paddingLeft: 2 }}>{hit.symbol}</h4>

                        </div>
                      </button>
                    </td>
                    <td className="text-xs py-2 px-4 border-b text-center">${hit.lowestPrice}</td>

                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <div style={{ padding: 5 }}>
              <h5 style={{ margin: 0, padding: 0, color: 'red', fontSize: 12 }}>No lowest prices hit.</h5>
            </div>
          )}
        </div>
      ) : null} */}

    </div>
  ) : null;
};

export default WatchersComponent;
